import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import formatCnpj from '@brazilian-utils/format-cnpj';
import { useDispatch, useSelector } from 'react-redux';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';
import { Dropdown } from 'react-bootstrap';

import EconomicGroup from '~/components/pages/Portal/EconomicGroup';
import iconRevenda from '~/assets/images/Header/ic_revenda.svg';
import iconExit from '~/assets/images/Header/exit.svg';
import iconEmployee from '~/assets/images/Header/worker.svg';
import '~/components/styles/Global.css';

import {
  Container,
  ResaleContainer,
  ResaleContent,
  ReleaseIcon,
  ReleaseInfo,
  UserInfoContainer,
  UserTexts,
  AvatarIcon,
  DesktopWrapper,
  MobileWrapper,
  ColorIconDesktop,
  CreatedIconStyles,
  ConfigModal,
} from './styles';

function HeaderLapidar({ stores, disabledOnMobile, noMarginBottom, engineMenu }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const expand = useSelector(state => state.economicGroupReducer.expand);
  const economicGroupReducer = useSelector(state => state.economicGroupReducer);
  const classificationReducer = useSelector((state) => state.classificationReducer);

  const [userName, _] = useState('');
  const [userEmail, __] = useState('');
  const [storeName, setStoreName] = useState('');
  const [storeDocument, setStoreDocument] = useState('');

  const storeDocumentLocal = localStorage.getItem('storeDocumentLapidar');

  useEffect(() => {
    dispatch({ type: 'SET_EXPAND', expand: false });
  }, []);

  useEffect(() => {
    setStoreName(localStorage.getItem('storeNameLapidar') ? localStorage.getItem('storeNameLapidar') : localStorage.getItem('storeName'));
    setStoreDocument(localStorage.getItem('storeDocumentLapidar') ? localStorage.getItem('storeDocumentLapidar') : localStorage.getItem('storeDocument'));
  }, [classificationReducer.selectedStoreLapidar, storeDocumentLocal]);

  return (
    <Container disabledOnMobile={disabledOnMobile}>
      <DesktopWrapper>
        <ResaleContainer>
          <EconomicGroup lapidar stores={stores} mobile={false}>
            <ResaleContent noMarginBottom={noMarginBottom} expand={economicGroupReducer.expand}>
              <ReleaseIcon src={iconRevenda} alt="icone revenda" />
              <ReleaseInfo color="#000fff">
                {storeName} - CNPJ: {formatCnpj(storeDocument)}
              </ReleaseInfo>
              {expand ? (
                <ExpandLessIcon style={ColorIconDesktop} />
              ) : (
                <ExpandMoreIcon style={ColorIconDesktop} />
              )}
            </ResaleContent>
          </EconomicGroup>
          {engineMenu && (
            <Dropdown
              style={{
                width: '493px',
                textAlign: 'right',
                marginTop: 10,
              }}
              drop="down"
            >
              <ConfigModal id="dropdown-custom-components">
                <i class="fa fa-cog" aria-hidden="true" />
              </ConfigModal>
              <Dropdown.Menu id="dropdown-logout">
                <b>Opções</b>
                {!localStorage.getItem('ownerid') && (
                  <Dropdown.Item
                    style={{
                      marginLeft: -25,
                      marginTop: 10,
                      width: '100%',
                      color: '#808080',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    onClick={() => {
                      history.push('/usuarios');
                    }}
                  >
                    <img
                      src={iconEmployee}
                      className="mr-2"
                      fill="#3E83F8"
                      style={{ transform: 'scaleX(-1)' }}
                      alt='icone Funcionario'
                    />
                    Lista de usuários
                  </Dropdown.Item>
                )}
                <Dropdown.Item
                  style={{
                    marginLeft: -25,
                    marginTop: 10,
                    width: '100%',
                    color: '#808080',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  onClick={() => {
                    dispatch({
                      type: "RESET_NOTIFICATION"
                    });
                    localStorage.clear();
                    setTimeout(() => {
                      window.location.href = '/';
                    }, 3000);
                  }}
                >
                  <img
                    src={iconExit}
                    className="mr-2"
                    fill="#000FFF"
                    style={{ transform: 'scaleX(-1)' }}
                    alt='icone sair'
                  />
                  Sair do MAP
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </ResaleContainer>
        {userName ? (
          <UserInfoContainer>
            <AvatarIcon className="fa fa-user-circle" alt="Avatar icon" />
            <UserTexts color="#000FFF">
              <h6>
                Olá, {userName !== 'undefined' && userName}
                <button onClick={() => history.push('/editar-perfil')}>
                  <CreateOutlinedIcon style={CreatedIconStyles} />
                </button>
              </h6>
              <span>{userEmail}</span>
            </UserTexts>
          </UserInfoContainer>
        ) : null}
      </DesktopWrapper>
      <MobileWrapper lapidar>
        <ResaleContainer lapidar>
            <EconomicGroup lapidar={true} stores={stores} mobile={true}>
            <ResaleContent noMarginBottom={noMarginBottom} expand={economicGroupReducer.expand}>
              <ReleaseIcon src={iconRevenda} alt="icone revenda" />
              <ReleaseInfo color="#000fff">
                {storeName} - CNPJ: {formatCnpj(storeDocument)}
              </ReleaseInfo>
              {expand ? (
                <ExpandLessIcon style={ColorIconDesktop} />
              ) : (
                <ExpandMoreIcon style={ColorIconDesktop} />
              )}
            </ResaleContent>
          </EconomicGroup>
        </ResaleContainer>
      </MobileWrapper>
    </Container>
  );
}

export default HeaderLapidar;
